// Label anchors are representative points from the USAID/PacIOOS
// mh_mgd_all_atolls layer. Nadikdik (Knox) is added from the NGA geographic
// name record because it is not a separate feature in that PacIOOS release.
// The detailed coastline itself comes from the portal's existing rmiLand.json.
export const RMI_ATOLL_LABELS = [
  { name: 'Ailinginae', kind: 'Atoll', position: [166.40673, 11.15038], priority: 35 },
  { name: 'Ailinglaplap', kind: 'Atoll', position: [168.72250, 7.43623], priority: 65 },
  { name: 'Ailuk', kind: 'Atoll', position: [169.94139, 10.34478], priority: 45 },
  { name: 'Arno', kind: 'Atoll', position: [171.63279, 7.13475], priority: 75 },
  { name: 'Aur', kind: 'Atoll', position: [171.08166, 8.25073], priority: 45 },
  { name: 'Bikar', kind: 'Atoll', position: [170.10459, 12.23836], priority: 20 },
  { name: 'Bikini', kind: 'Atoll', position: [165.37512, 11.60374], priority: 60 },
  { name: 'Bokak', kind: 'Atoll', position: [168.98423, 14.63736], priority: 20 },
  { name: 'Ebon', kind: 'Atoll', position: [168.71011, 4.62944], priority: 55 },
  { name: 'Enewetak', kind: 'Atoll', position: [162.22016, 11.50939], priority: 65 },
  { name: 'Erikub', kind: 'Atoll', position: [170.02538, 9.13461], priority: 20 },
  { name: 'Jabat', kind: 'Island', position: [168.97827, 7.75344], priority: 45 },
  { name: 'Jaluit', kind: 'Atoll', position: [169.56357, 6.04669], priority: 75 },
  { name: 'Jemo', kind: 'Island', position: [169.54030, 10.09120], priority: 20 },
  { name: 'Kili', kind: 'Island', position: [169.12252, 5.64421], priority: 50 },
  { name: 'Kwajalein', kind: 'Atoll', position: [167.62721, 9.06066], priority: 95 },
  { name: 'Lae', kind: 'Atoll', position: [166.23685, 8.94091], priority: 45 },
  { name: 'Lib', kind: 'Island', position: [167.37936, 8.31316], priority: 45 },
  { name: 'Likiep', kind: 'Atoll', position: [169.11235, 9.92765], priority: 50 },
  { name: 'Majuro', kind: 'Atoll', position: [171.17128, 7.13895], priority: 100 },
  { name: 'Maloelap', kind: 'Atoll', position: [171.09495, 8.69822], priority: 55 },
  { name: 'Mejit', kind: 'Island', position: [170.86923, 10.28669], priority: 45 },
  { name: 'Mili', kind: 'Atoll', position: [171.93796, 6.06895], priority: 65 },
  { name: 'Nadikdik', kind: 'Atoll', position: [172.15000, 5.91667], priority: 20 },
  { name: 'Namdrik', kind: 'Atoll', position: [168.11233, 5.61758], priority: 55 },
  { name: 'Namu', kind: 'Atoll', position: [168.17470, 7.97885], priority: 50 },
  { name: 'Rongelap', kind: 'Atoll', position: [166.76464, 11.32522], priority: 55 },
  { name: 'Rongerik', kind: 'Atoll', position: [167.44600, 11.34476], priority: 20 },
  { name: 'Taka', kind: 'Atoll', position: [169.61861, 11.14490], priority: 20 },
  { name: 'Ujae', kind: 'Atoll', position: [165.62822, 9.07547], priority: 45 },
  { name: 'Ujelang', kind: 'Atoll', position: [160.89534, 9.82077], priority: 35 },
  { name: 'Utrik', kind: 'Atoll', position: [169.78667, 11.27271], priority: 50 },
  { name: 'Wotho', kind: 'Atoll', position: [165.97290, 10.09980], priority: 45 },
  { name: 'Wotje', kind: 'Atoll', position: [170.03231, 9.45005], priority: 65 },
];

